export class ChartRoot {
    constructor(name, rows) {
        this.name = name;
        this.rows = rows;
        // this.rows.sort((a, b) => { return a.ordinal - b.ordinal })
    }
}
